import React from "react";
import { array, string } from "prop-types";

import DfpAd from "../../../dfp-ad";
import Organism1 from "../Organism1";
import NewsWithNoImage from "../../../molecules/NewsWithNoImage";

import "./row1.m.css";

const Row1 = ({ stories, collectionSlug, adSlotId2, widgetUrl, lang, pageType }) => {
  const row1FirstStories = stories.slice(0, 1);
  const row1SecondStories = stories.slice(1, 2);

  return (
    <React.Fragment>
      {row1FirstStories && <Organism1 story={row1FirstStories[0].story} />}

      <div styleName="ads">
        <div styleName="inner_ads">
          <DfpAd
            adtype={lang === "en" ? "EnPalo_HP_336x280_R1" : "Home_336x280_R1"}
            collectionSlug={collectionSlug}
            layoutName="HomeFeaturedR1Ads"
            slotId={adSlotId2}
          />
        </div>
      </div>
      <div styleName="second_story" className={widgetUrl ? "widget-present" : ""}>
        {row1SecondStories && <NewsWithNoImage story={row1SecondStories[0].story} Htag="h2" />}
        {widgetUrl && (
          <div styleName="widget-available">
            <iframe title="row 1 iframe title" src={widgetUrl} styleName="widget-iframe"></iframe>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

Row1.propTypes = {
  stories: array.isRequired,
  collectionSlug: string,
  adSlotId2: string,
  widgetUrl: string,
  lang: string,
  pageType: string,
};

export default Row1;
